<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
    <footer ref="videoContainer" @click="playVoice" id="footer">
      <button @click="playVoice">播放通知</button>
    </footer>
  </div>
</template>

<script>
var mp3 = null;
import newInquiryOrderVideo from "./assets/tts.mp3";
import urlObj from './config/env.js'
export default {
  name: "App",
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isRouterAlive: true,
      confirm: "", // 作为响应式属性
      audioSrc: newInquiryOrderVideo, // 你的音频源路径
      websocket: null, // WebSocket实例
      isRouterAlive: true,
    };
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    },
    connectWebSocket() {
      let reqUrl = urlObj.wss;
      // let slicedPart =
      //   reqUrl.slice(reqUrl.indexOf("//") + 2) || "192.168.30.218:9220";
      console.log(reqUrl, "omsEdit    reqUrl");
      // return;
      const mapData = {
        // uat
        "https://wssuatapi.g-parts.cn/": "wsspartuatapi.g-parts.cn",
        // pro
        "https://wssapi.g-part.cn/": "wsspartapi.g-part.cn",
      };
      let tenantId = JSON.parse(localStorage.getItem('userdetails_tenantInfo'))
              .tenantId;
      let url =
        // "wss://" + mapData[reqUrl] + "/gateway/api/webSocketServer/" + tenantId;
      "wss://" + mapData[reqUrl]+"/wss-part/gateway/api/webSocketServer/" + tenantId;
      console.log(url,"wss地址")
      // "wss://testmallapi.g-parts.cn/api/webSocketServer/ad9b1a612994498cb29ae9ae1d527238" ||

      if ("WebSocket" in window) {
        this.websocket = new WebSocket(url);
      }

      this.websocket.addEventListener("message", (e) => {
        console.log(e, "建立连接——————————————————————————");
        if (e.data === "存在销售单") {
          console.log("执行_________");
          this.playVoice();
        }
      });

      this.websocket.addEventListener("error", (e) => {
        console.log(e, "报警_________");
      });
      this.websocket.addEventListener("close", () => {
        console.log("WebSocket连接已经关闭，正在重新连接...");
        // 等待一段时间后重新调用连接函数
        setTimeout(this.connectWebSocket(), 3000); // 3秒后重新连接
      });
    },
    playVoice() {
      // var utterThis = new window.SpeechSynthesisUtterance("支付宝到账");
      // window.speechSynthesis.speak(utterThis);
      let url = this.audioSrc;
      // "http://downsc.chinaz.net/Files/DownLoad/sound1/201906/11582.mp3";
      console.log("播放录音---" + url);
      if (mp3 != null) {
        mp3.pause();
        mp3 = new Audio(url);
        mp3.play();
      } else {
        mp3 = new Audio(url);
        mp3.play(); //播放 mp3这个音频对象
      }
    },
  },
  mounted() {
    // 初始连接
    this.connectWebSocket();

    return;
    setTimeout(() => {
      let videoContainer = this.$refs.videoContainer;
      // 模拟用户点击
      videoContainer.dispatchEvent(new Event("click"));
    }, 2000);
  },
  beforeDestroy() {
    // 销毁
    if (this.websocket !== null) {
      this.websocket.close();
    }
  },
  computed: {
    getRouteKey() {
      // 当前路由的唯一key
      return this.$route.name + (this.$route.params.id || "");
    },
  },

  watch: {
    $route: {
      handler(val) {
        if (val.name == "login") return;
        this.$ButtonShow();
      },
      deep: true,
    },
  },
};
</script>

<style lang="less" >
html,
body,
#app {
  // text-align: center;
  width: 100%;
  height: 100%;
}
body {
  // background: #f6f6f6 !important;
  font-size: 14px;
  // background-color: #f5f5f8 !important;
}
.main-inner {
  background: #fff;
}
</style>
